import * as React from "react";
import { Provider } from "react-redux";
import ReduxToastr from "react-redux-toastr";
import { BrowserRouter as Router, Route } from "react-router-dom";

import store from "./store";

import Menu from "./components/structure/Menu";
import Nav from "./components/structure/Nav";

// get the screens
import Home from "./components/Home";
import Login from "./components/Login/LoginScreen";
import KnownEventsScreen from "./components/Events/Events";
import ManagePlansScreen from "./components/Billing/ManagePlans";


class App extends React.Component {

  public render() {
    return (
      <Provider store={store}>
        <Router>
          <Menu>
            <div className="container-fluid">
              <Nav />
              <div>
                <div className="row">
                  <div className="col-md-10 col-md-offset-1">
                    <Route exact={true} path="/" component={Home} />
                    <Route exact={true} path="/login" component={Login} />
                    
                    <Route exact={true} path="/events/knownEvents" component={KnownEventsScreen} />
                    <Route exact={true} path="/billing/plans" component={ManagePlansScreen} />
                  </div>
                </div>
              </div>

              <ReduxToastr
                timeOut={3000}
                newestOnTop={false}
                preventDuplicates={true}
                position="top-center"
                transitionIn="fadeIn"
                transitionOut="fadeOut"
                progressBar={true} />
            </div>
          </Menu>
        </Router>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx